import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

function MessageBox(params) {
  const { icon, title, text } = params;

  const MySwal = withReactContent(Swal);

  return MySwal.fire({
    icon: icon,
    title: title,
    text: text,
  });
}

export default MessageBox;

// import React, { useState } from 'react';
// /* import Swal from 'sweetalert2'; */
// import DialogBox from '../DialogBox';

// function MessageBox(props) {
//   const { icon, title, text, labelOk, onConfirm } = props;
//   //const [aa, setAa] = React.useState();
//   console.log('MessageBox', icon, title, text);
//   /* return Swal.fire({
//     customClass: {
//       container: "my-swal"
//     },
//     icon: icon,
//     title: title,
//     text: text,
//     confirmButtonText: labelOk,
//     heightAuto: false
//   }).then(() => {
//     if (onConfirm) onConfirm();
//   }); */
//   return (
//     <div>
//       <DialogBox open={true} icon title text buttonOk={true} onConfirm />
//     </div>
//   );
// }
